// Native auto-login cookie key (read for webview detection; auth handled by hive-auth)
export const IN_APP_LOGIN_KEY = "autologin_data";
// sessionStorage key used to relay an auth error message to the login screen
// (e.g. when a token-authenticated user turns out not to be a telehealth patient)
export const LOGIN_ERROR_MESSAGE_KEY = "loginErrorMessage";

export const COACHSERVER_URL = process.env.HIVE_COACHSERVER_URL;
export const GROWTH_INSURANCE_API = process.env.HIVE_GROWTH_INSURANCE_API;
export const WEB_BUYFLOW_DOMAIN = process.env.HIVE_WEB_BUYFLOW_DOMAIN;
export const HEALTHCARE_API = process.env.HIVE_HEALTHCARE_API;
export const COOKIE_DOMAIN = process.env.HIVE_COOKIE_DOMAIN;
export const NOOM_ENVIRONMENT = process.env.HIVE_NOOM_ENVIRONMENT;
export const DEEP_LINK_BASE = process.env.HIVE_DEEP_LINK_BASE;

// Datadog RUM. All optional: with no application ID / client token the SDK is
// never initialized and the app behaves exactly as before, which is the default
// for local development and CI.
export const DATADOG_APPLICATION_ID = process.env.HIVE_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = process.env.HIVE_DATADOG_CLIENT_TOKEN;
export const DATADOG_ENVIRONMENT =
  process.env.HIVE_DATADOG_ENVIRONMENT ?? "development";
// Set from the Amplify commit SHA at build time (see `amplify.yml`) so errors
// and regressions can be attributed to a specific deploy.
export const DATADOG_VERSION = process.env.HIVE_DATADOG_VERSION ?? "latest";
